































































import { Component, Prop, Vue } from "vue-property-decorator";

// uppy and plugins
const Uppy = require("@uppy/core");
const Dashboard = require("@uppy/dashboard");
const xhr = require("@uppy/xhr-upload");
const Form = require("@uppy/form");

// axios for post request
const axios = require("axios");

// And their styles (for UI plugins)
require("@uppy/core/dist/style.css");
require("@uppy/dashboard/dist/style.css");

interface sessionFormI {
  unixtime: number;
  uniqid: string;
  realname: string;
  email: string;
  phone: string;
  terms: boolean;
  session: string;
}

@Component
export default class UploadForm extends Vue {
  private sessionForm: sessionFormI = {
    unixtime: Date.now(),
    uniqid: this.uniqidGenerator(),
    realname: this.$store.state.contactForm.name,
    email: this.$store.state.contactForm.email,
    phone: this.$store.state.contactForm.phone,
    terms: this.$store.state.contactForm.terms,
    session: ""
  };

  private uppy_result: string = "nothing uploaded yet!";

  checkForTerms() {
    if (this.$store.state.contactForm.terms != true) {
      this.$router.push({ name: "start" });
    }
  }

  uniqidGenerator() {
    var id =
      String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(65 + Math.floor(Math.random() * 26));
    id = id.toLowerCase();
    return id;
  }

  uppyInit() {
    const uppy = Uppy({
      debug: true,
      autoProceed: false,
      restrictions: {
        maxFileSize: null,
        // set min and max for use case
        maxNumberOfFiles: 4,
        minNumberOfFiles: 4,
        allowedFileTypes: [".gz"] // only compressed nifti files
      },
      onBeforeFileAdded: (currentFile: any) => {
        const isCorrectExtension = currentFile.name.endsWith(".nii.gz");
        if (!isCorrectExtension) {
          uppy.info(
            uppy.i18n("youCanOnlyUploadFileTypes", {
              types: ".nii.gz"
            }),
            "error",
            5000
          );
          return false;
        } else {
          return true;
        }
      }
    });
    uppy.use(Dashboard, {
      inline: true,
      target: "#uppylocation",
      showProgressDetails: true,
      note: "please select the T1, T1c, T2 and FLAIR .nii.gz file of the exam.",
      width: 1280,
      height: 350
    });
    uppy.use(xhr, {
      endpoint: process.env.VUE_APP_UPLOAD,
      method: "post",
      formData: true,
      fieldName: "files[]",
      bundle: false
    });

    uppy.use(Form, {
      target: "#contact",
      resultName: "uppy_result",
      getMetaFromForm: true,
      addResultToForm: true,
      multipleResults: false,
      submitOnSuccess: false,
      triggerUploadOnSubmit: false
    });

    uppy.on("complete", (result: any) => {
      this.uppy_result = result;
      console.log("uppy result: " + result);
      console.log("successful files: ", result.successful);
      console.log("failed files: ", result.failed);
      console.log(result.failed);
      if (result.failed === undefined || result.failed.length == 0) {
        // create data for POST
        const payload = JSON.stringify(this.sessionForm);
        console.log(payload);

        // create POST request
        axios({
          method: "post",
          url: process.env.VUE_APP_BRATSSEG,
          data: payload
        });

        // axios({ method: "GET", "url": "https://httpbin.org/ip" }).then(result => {
        //         this.ip = result.data.origin;
        //     }, error => {
        //         console.error(error);
        //     });
        // }

        // redirect
        console.log("contact success - redirecting!");
        this.$router.push({ name: "thanks" });
      }
    });
  }

  mounted() {
    // redirect to start if terms are not accepted
    this.checkForTerms();

    // set session
    this.sessionForm.session =
      this.sessionForm.unixtime +
      "_" +
      this.sessionForm.uniqid +
      "_" +
      this.sessionForm.email;

    // init uppy
    this.uppyInit();
  }
}
